/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */

import produce from 'immer'
import {
  CHANGE_TYPE_NOTE_MESSAGE,
  CHANGE_TYPE_SUMMARY_MESSAGE,
} from '../constants'
import {
  selectConversationEventGroupsById,
  selectMessagesById,
} from '../selectors'

export const mergeTicketEntities = getState => normalizedEntities => {
  const state = getState()
  const messagesById = selectMessagesById(state)
  const eventGroupsById = selectConversationEventGroupsById(state)

  return produce(normalizedEntities, draftTransformedEntities => {
    if (draftTransformedEntities.conversationEventGroup) {
      Object.keys(draftTransformedEntities.conversationEventGroup).forEach(
        eventGroupsId => {
          const newEventGroup =
            draftTransformedEntities.conversationEventGroup[eventGroupsId]
          const existingEventGroup = eventGroupsById[eventGroupsId]
          if (!existingEventGroup || existingEventGroup.collapsed) return
          newEventGroup.collapsed = false
        }
      )
    }

    if (draftTransformedEntities.message) {
      Object.keys(draftTransformedEntities.message).forEach(messageId => {
        const newMessage = draftTransformedEntities.message[messageId]
        const existingMessage = messagesById[messageId]
        if (
          !existingMessage ||
          [CHANGE_TYPE_SUMMARY_MESSAGE, CHANGE_TYPE_NOTE_MESSAGE].includes(
            existingMessage.__typename
          )
        )
          return
        newMessage.__typename = existingMessage.__typename
        // Dont overwrite parts if they are already present
        newMessage.parts = existingMessage.parts
      })
    }
  })
}
